import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function FlaskIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M9.5 4.25V4.1996C9.5 4.07344 9.44265 3.95412 9.34414 3.87531L9.13932 3.71146C8.42995 3.14396 8.83123 2 9.73967 2H14.2603C15.1688 2 15.57 3.14396 14.8607 3.71146L14.6559 3.87531C14.5573 3.95412 14.5 4.07344 14.5 4.1996V5.31802C14.5 7.35541 15.3093 9.30935 16.75 10.75L17.136 11.136C18.3295 12.3295 19 13.9482 19 15.636C19 19.1508 16.1508 22 12.636 22H11.364C7.84924 22 5 19.1508 5 15.636C5 13.9482 5.67049 12.3295 6.86396 11.136L7.25 10.75C7.85504 10.145 8.34873 9.44939 8.71788 8.69513C8.80497 8.73051 8.90021 8.75 9 8.75H10.5C10.9142 8.75 11.25 8.41421 11.25 8C11.25 7.58579 10.9142 7.25 10.5 7.25H9.25311C9.37998 6.7618 9.45918 6.25951 9.48786 5.75H11.5C11.9142 5.75 12.25 5.41421 12.25 5C12.25 4.58579 11.9142 4.25 11.5 4.25H9.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
